class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.nav = document.querySelector('[data-nav-primary]');
    // Find all main collapsible elements in the drawer
    this.collapsibles = this.querySelectorAll('.main-menu-drawer__collapsible');

    // get all the links in the nav that open the drawer
    this.links = this.nav.querySelectorAll('button[data-drawer-controller]');

    this.links.forEach((link) => {
      link.addEventListener('click', () => {
        const label = link.getAttribute('aria-label');
        //find corresponding collapsible in the drawer
        this.controller = this.querySelector(`[aria-label="${label}"]`);
        //Open the collapsible
        this.controller.setAttribute('aria-expanded', 'true');
        this.controller.classList.add('underline');
        //Find the content of the collapsible
        const id = this.controller.getAttribute('aria-controls');
        //Find the content of the collapsible and open it
        this.querySelector(`#${id}`).setAttribute('aria-hidden', 'false');
        //Close all other main collapsibles
        this.closeOtherCollapsibles(id);
      });
    });

    //On click collapsible, close all other main collapsibles
    this.collapsibles.forEach((collapsible) => {
      const button = collapsible.querySelector('button');
      collapsible.addEventListener('click', () => {
        button.classList.add('underline');
        const id = button.getAttribute('aria-controls');
        //Close all other main collapsibles
        this.closeOtherCollapsibles(id);
      });
    });
  }

  /**
   * Close all other main collapsibles
   */
  closeOtherCollapsibles(id) {
    this.collapsibles.forEach((collapsible) => {
      const button = collapsible.querySelector('button');
      this.close(collapsible, button, id);
    });
  }

  close(collapsible, button, id) {
    //If the id is not the same as the button's aria-controls, close the collapsible
    if (id !== button.getAttribute('aria-controls')) {
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('underline');
      const id = button.getAttribute('aria-controls');
      collapsible.querySelector(`#${id}`).setAttribute('aria-hidden', 'true');
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);
